import { render, staticRenderFns } from "./NetaMultiAttractionDetailsView.vue?vue&type=template&id=54d00212&scoped=true&"
import script from "./NetaMultiAttractionDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaMultiAttractionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiAttractionDetailsView.vue?vue&type=style&index=0&id=54d00212&lang=scss&scoped=true&"
import style1 from "./NetaMultiAttractionDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d00212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d00212')) {
      api.createRecord('54d00212', component.options)
    } else {
      api.reload('54d00212', component.options)
    }
    module.hot.accept("./NetaMultiAttractionDetailsView.vue?vue&type=template&id=54d00212&scoped=true&", function () {
      api.rerender('54d00212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaMultiAttractionDetailsView.vue"
export default component.exports